import { Navigate, Outlet } from "react-router-dom";

import { useAccount } from "components/AccountProvider";
import SpinnerOverlay from "components/SpinnerOverlay";
import AccessPendingApprovalPage from "pages/accessPending/AccessPendingApprovalPage";

/**
 * Route guard for the company-scoped routes: a user needs an approved active company to see them.
 * - While accounts load, a spinner.
 * - A user with zero accounts is redirected to the "no company access" page.
 * - A user whose active company is still awaiting approval sees the "access pending approval" page
 *   (see ADR 0003), rendered in place of the company content under the base/master shell.
 *
 * The SSOID-scoped master routes (My Profile, Accounts & Roles, Request Company Account,
 * No Company Access) must NOT be wrapped by this guard so they stay reachable while pending.
 */
export default function RequireCompanyAccess() {
	const { accounts, isLoading, activeAccountPending } = useAccount();

	if (isLoading) {
		return <SpinnerOverlay open />;
	}

	if (accounts.length === 0) {
		return <Navigate to="/NoCompanyAccess" replace />;
	}

	if (activeAccountPending) {
		return <AccessPendingApprovalPage />;
	}

	return <Outlet />;
}
